module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/esports-teams/esports-team-list/esports-team-list.component.scss
// module id = ./libs/atenea-cms-brand/src/esports-teams/esports-team-list/esports-team-list.component.scss
// module chunks = main